import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Message } from "@/components/ui/message";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import z from "zod";

const schema = z.object({
  oldPassword: z.string().min(2),
  newPassword: z.string().min(6),
});

export type ChangePasswordFormData = z.infer<typeof schema>;

interface ChangePasswordFormProps {
  isPending?: boolean;
  onSubmit: (data: ChangePasswordFormData) => void;
}

export const ChangePasswordForm = ({ isPending, onSubmit }: ChangePasswordFormProps) => {
  const { control, handleSubmit } = useForm<ChangePasswordFormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      oldPassword: "",
      newPassword: "",
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <Controller
        name="oldPassword"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <Label>Current Password</Label>
            <Input type="password" placeholder="Current password" disabled={isPending} {...field} />
            {error?.message && <Message variant="error">{error.message}</Message>}
          </>
        )}
      />

      <Controller
        name="newPassword"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <Label>New Password</Label>
            <Input type="password" placeholder="New password" disabled={isPending} {...field} />
            {error?.message && <Message variant="error">{error.message}</Message>}
          </>
        )}
      />

      <Button type="submit" disabled={isPending}>
        {isPending ? "Updating..." : "Update password"}
      </Button>
    </form>
  );
};
